import React, { useEffect, useState } from "react";
import {
  CancelButton,
  SubmitButton,
} from "../../../../Components/Utils/Buttons";
import FormikSelectTwo from "../../../../Components/Utils/Select";
import Pagination from "../../../../Components/Utils/Pagenation";
import CustomDataTable from "../../../../Components/Others/CustomDataTable";
import { useLocation, useParams } from "react-router-dom";
import axiosInstance from "../../../../Services/axiosCommon";
import * as yup from "yup";
import UseGetDataSearchByProUser from "../../../../Components/Hooks/useFetchDataByPROUser";
import { useFormik } from "formik";
import ClientManagementLayout from "../ClientManagementLayout";
import { GetAccess } from "../../../../Components/Utils/roles";
import { NuInput } from "../../../../Components/Utils/Input";

import CloseIcon from "../../../../Components/Icons/Close";
import useFetchMDIndex from "../../../../Components/Hooks/useFetchMDIndex";
import ImportFileModal from "../../../../Components/Utils/ImportFileComponent";
import EquipDetailsLayout from "../EquipDetailsLayput";
import CreateEquipmentEqu from "./Create";
import UseGetDataSearchByEqu from "../../../../Components/Hooks/useFetchDataByEqu";
import useFetchMataData from "../../../../Components/Hooks/useFetchMataData";
import { formatDate } from "../../../../Components/Utils/NuDate";
import EquipLayout from "../EquipLayput";
import DetailsEquipCard from "../../../Mobile/ClientManage/Contract/DetailsEquipCard";
import { Braces } from "lucide-react";

function EquipDetailsIndex() {
  const [screenSize, setScreenSize] = useState({
    width: window.innerWidth,
  });

  useEffect(() => {
    const handleResize = () => {
      setScreenSize({
        width: window.innerWidth,
      });
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);
  const { contractsViewId, id } = useParams();

  const [open, setOpen] = useState(false);
  const location = useLocation();
  const state = location.state;
  const equipment_data = state?.data;

  const currentPage = location.state?.currentPage;
  const searchQuery = location.state?.searchQuery;
  const [page, setPage] = useState(currentPage || 1);
  const [pageCount, setPageCount] = useState(
    localStorage.getItem("perPageView") || 20
  );

  const [itemName, setItemName] = useState("-");
  const [unit, setUnit] = useState("-");


  const { value: type, getData: reftype } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "type_equipments"
  );
  const { value: units, getData: refunit } = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "unit_equipments"
  );
  const [filter, setFilter] = useState(
    state?.approvalStatus || state?.industry ? true : false
  );
  const [showFilterDialog, setShowFilterDialog] = useState(false);
  const [showExport, setShowExport] = useState(false);

  const { value: status } = useFetchMDIndex(
    `/dropdown/dropdown-details/`,
    "Status_Contracts",
    [showFilterDialog, showExport],
    () => showFilterDialog || showExport
  );

  const [filterProps, setFilterProps] = useState({
    equipmentId: id,

    location: "",
    type: "",
    unit: "",
  });
  const [params, setParams] = useState({
    equipmentId: id,
    search: searchQuery || "",
    page: page,
    per_page: pageCount,
    location: "",
    type: "",
    unit: "",
  });
  const clearFilter = () => {
    setParams({
      ...params,
      equipmentId: id,
      location: "",
      type: "",
      unit: "",
    });
    formik.values.location = "";
    formik.values.type = "";
    formik.values.unit = "";

    setFilter(false);
  };

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: filterProps,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
      // email: yup.string().required('Email is required!'),
    }),
    onSubmit: async (value, { resetForm }) => {
      console.log("ffff", value);
      setParams({
        ...params,
        equipmentId: value.equipmentId,
        location: value.location,
        type: value.type,
        unit: value.unit,
      });
      closeFilterDialog();
      setFilter(true);
      setFilterProps({
        equipmentId: id,

        location: "",
        type: "",
        unit: "",
      });
    },
  });

  const { data, totalCount, getData, dataLoading, quantity } =
    UseGetDataSearchByEqu(`/equipment-details/getall`, params);
  const [viewMode, setViewMode] = useState(
    localStorage.getItem("viewMode") || "card"
  );



  const defaultHeader = [
    {
      title: "SL No.",
      width: "5%",
      // isLink: true,
      // id: "id",
      // link: `/Contract-management/contracts/equipments/${contractsViewId}/equipDetails/${id}/view/`,
      field: "sno",
      textAlign: "left",
      rowAlign: "left",
    },
    {
      title: "ID/Tag Number",
      width: "12.87%",
      // isLink: true,
      // id: "id",
      // link: `/Contract-management/contracts/equipments/${contractsViewId}/equipDetails/${id}/view/`,
      field: "idNumber",
      textAlign: "left",
      rowAlign: "left",
    },

    {
      title: "Equipment",
      width: "12.87%",
      field: "itemName",
      textAlign: "left",
      rowAlign: "left",
      // isLink: true,
      // id: "id",
      // link: `/Contract-management/contracts/equipments/${contractsViewId}/equipDetails/${id}/view/`,
    },

    {
      title: "Type ",
      width: "12.87%",
      field: "type",
      textAlign: "left",
      rowAlign: "left",
    },

    {
      title: "Location ",
      width: "12.87%",
      field: "location",
      textAlign: "left",
      rowAlign: "left",
    },
    {
      title: "Capacity ",
      width: "12.87%",
      field: "capacity",
      textAlign: "left",
      rowAlign: "left",
    },

    {
      title: "Action",
      width: "10%",
      field: "action",
      textAlign: "center",
      rowAlign: "center",
      contents: {
        // fetcher:getData,
        id: "id",
        removeValue: "itemName",
        url: `/equipment-details/delete/`,
        moduleName: "Equipment Details",
        from: `/Contract-management/contracts/equipments/${contractsViewId}/equipDetails/${id}`,
        // editLink: `/Contract-management/contracts/equipments/${contractsViewId}/equipDetails/${id}/edit/`,
        // viewLink: `/Contract-management/contracts/equipments/${contractsViewId}/equipDetails/${id}/view/`,
      },
    },
  ];
  const availableHeaders = [];
  useEffect(() => {
    localStorage.setItem("viewMode", viewMode);
    setParams({ ...params, page: page, per_page: pageCount });
  }, [page, pageCount, viewMode]);

  const closeFilterDialog = () => {
    setShowFilterDialog(false);
  };
  const [showImportModal, setShowImportModal] = useState(false);
  const [createModalOpen, setCreateModalOpen] = useState(false);

  const handleImportClick = () => {
    setShowImportModal(true);
  };

  const closeModal = () => {
    setShowImportModal(false);
  };
  const [exportValue, setExportValue] = useState({
    equipmentId: id,
    location: "",
    type: "",
    unit: "",
    typeEquipment: "",
    brand: "",
  });
  const ExportFormik = useFormik({
    enableReinitialize: true,
    initialValues: exportValue,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: async (value, { resetForm }) => {
      try {
        const response = await axiosInstance.get(
          `/equipment-details/export/${id}?unit=${value.unit}&type=${value.typeEquipment}&location=${value.location}`,
          {
            responseType: "blob",
          }
        );

        const pdfBlob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });

        const link = document.createElement("a");
        link.href = window.URL.createObjectURL(pdfBlob);
        // link.download = `Contract Report ${NuDateFormate({
        //   value: new Date(),
        //   format: "DD-MMM-YYYY",
        // })}.xlsx`;

        link.download = `Equipment Report ${formatDate(new Date())}.xlsx`;

        document.body.appendChild(link);
        link.click();

        link.parentNode.removeChild(link);

        resetForm({ values: exportValue });
      } catch (error) {
        console.error("Error downloading the PDF:", error);
      }
    },
  });

  const closeFilterDialogebox = () => {
    setShowExport(false);
  };

  const [showEdit, setShowEdit] = useState(false);
  const [listofNumbers, setListofNumbers] = useState([]);
  const [fullList, setFullList] = useState([]);

  const selectOneFunction = (value) => {
    let NewId;
    if (listofNumbers && listofNumbers.some((Item) => Item === value)) {
      NewId = listofNumbers.filter((Temp) => Temp !== value);
      setListofNumbers(NewId);
    } else {
      setListofNumbers([...listofNumbers, value]);
    }
  };

  const selectMultipleFunction = (e) => {
    if (e.target.checked) {
      setListofNumbers(fullList);
    } else {
      setListofNumbers([]);
    }
  };

  useEffect(() => {
    let tempArr = [];
    data &&
      data.forEach((i) => {
        tempArr.push(i?.id);
      });
    setFullList(tempArr);
  }, [data]);

  const [valueOfSearch, setValuesofSearch] = useState("");
  function searchFunction(e) {
    setValuesofSearch(e?.target?.value);
    setParams({ ...params, search: e?.target?.value, page: 1 });
    setPage(1);
  }

  return (
    <>
      <EquipLayout
        setOpen={setShowImportModal}
        searchFun={searchFunction}
        onCreateClick={() => setCreateModalOpen(true)}
        getData={getData}
        isCard={false}
        isFilter={filter}
        newfilter={true}
        setFilterOpen={setShowFilterDialog}
        ClearFilter={clearFilter}
        CreateAccess={GetAccess("equipment_details_create")}
        ImportAccess={GetAccess("equipment_details_import")}
        ExportAccess={GetAccess("equipment_details_export")}
        searchValue={valueOfSearch}
        setViewMode={setViewMode}
        neededSearch={true}
        viewMode={viewMode}
        setOpenExport={setShowExport}
        // handleSearch={handleSearch}
        total={totalCount}
        quantity={quantity}
        itemName={equipment_data?.equipmentName}   // ✅ take first row’s itemName
        unit={equipment_data?.unit}
      >
       {screenSize.width <= 786 ? (
  <div className='w-full h-[calc(100vh-205px)] grid sm:grid-cols-2 gap-3 bg-white mt-1 rounded-lg shadow-lg overflow-auto p-2'>
    {data && data.length > 0 ? (
      data.map((item) => (
        <DetailsEquipCard
          key={item.id}
          item={item}
          getData={getData}
        />
      ))
    ) : (
      <div className="text-center p-4 text-gray-500">No equipment found</div>
    )}
  </div>
) : (
  <div className="w-full h-full">
    <CustomDataTable
      fetcher={getData}
      data={data}
      availableHeaders={availableHeaders}
      defaultHeader={defaultHeader}
      bodyHeight="max-h-[calc(100vh-260px)]"
      height="h-[calc(100vh-160px)]"
      total={totalCount}
      title="Equipment Details"
      pageIndex={params.page}
      setPageIndex={setPage}
      dataCount={params.per_page}
      setDataCount={setPageCount}
      storageName="EquipDetailEquTable"
      editAccess="quotes_edit"
      deteleAccess="quotes_delete"
      dataLoading={dataLoading}
      searchQuery={params?.search != "" ? params?.search : ""}
      selectOneFunction={selectOneFunction}
      // setShowEdit={setShowEdit}
      // showEdit={showEdit}
      listofNumbers={listofNumbers}
      selectMultipleFunction={selectMultipleFunction}
      fullList={fullList}
      getById="id"
    />
  </div>
)}

      </EquipLayout>

      {showFilterDialog && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
          <div className="animate-scale-in min-w-[40%] max-w-[80%] max-h-[80vh] bg-white py-4 px-6 rounded-md shadow-lg overflow-y-scroll">
            <h2 className="text-xl mb-4">Filter </h2>
            <form onSubmit={formik.handleSubmit}>
              <div className="sm:flex flex-col mb-4">
                <FormikSelectTwo
                  label="Type"
                  Options={type}
                  formik={formik}
                  placeholder="Choose"
                  name="type"
                  width="w-full  "
                />
                <NuInput
                  label="Location"
                  name="location"
                  formik={formik}
                  placeholder="Enter location"
                  width="w-full"
                />
                <FormikSelectTwo
                  label="Unit"
                  Options={units}
                  formik={formik}
                  placeholder="Choose"
                  name="unit"
                  width="w-full"
                />
              </div>
              <div className="flex justify-end gap-2">
                <CancelButton handleClick={closeFilterDialog} />
                <SubmitButton name="Apply" />
              </div>
            </form>
          </div>
        </div>
      )}

      {/* {showEdit && (
        <MultiEdiQuotes
          data={listofNumbers}
          getData={getData}
          onClose={() => setShowEdit(false)}
        />
      )} */}
      {showImportModal && (
        <ImportFileModal
          show={showImportModal}
          onClose={closeModal}
          apiUrl={`/equipment-details/import-equipment-details/${id}`}
          menuName="Equipment Details"
          getData={getData}
          additional_details_req={true}  
          url="/equipment-details/import-sample-file/con-equipment"
          required_columns={["Name", "Category", "Unit", "Quantity"]}

        />
      )}
      {createModalOpen && (
        <CreateEquipmentEqu
          open={createModalOpen}
          onCancel={() => {
            setCreateModalOpen(false);
          }}
          getData={getData}
        />
      )}
      {showExport && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
          <div className="animate-scale-in min-w-[85%] sm:min-w-[50%] 2xl:min-w-[40%] max-w-[50%] 2xl:max-w-[40%] max-h-[80vh] relative bg-white py-4 px-6 rounded-md shadow-lg overflow-y-scroll">
            <div className=" w-full flex justify-between items-center  bg-white">
              <h2 className=" text-sm 2xl:text-base font-medium ">
                Export Data
              </h2>
              <div
                className=" cursor-pointer "
                onClick={() => setShowExport(false)}
              >
                <CloseIcon />
              </div>
            </div>
            <form onSubmit={ExportFormik.handleSubmit}>
              <div className=" w-full flex flex-wrap">
                <div className=" w-full flex ">
                  <div className=" w-1/2 flex items-center px-6 py-3 ">
                    <input
                      id="default-radio-1"
                      type="radio"
                      value="all"
                      name="type"
                      className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300"
                      onChange={ExportFormik.handleChange}
                      checked={ExportFormik.values.type == "all"}
                    />
                    <label
                      htmlFor="default-radio-1"
                      className="ms-2 text-xs 2xl:text-sm  text-gray-900 "
                    >
                      All Data
                    </label>
                  </div>

                  <div className="w-1/2 flex items-center px-6 py-3">
                    <input
                      id="default-radio-2"
                      type="radio"
                      value="filter"
                      name="type"
                      className="w-4 h-4 text-blue-600 bg-gray-100 border-gray-300"
                      onChange={ExportFormik.handleChange}
                      checked={ExportFormik.values.type == "filter"}
                    />
                    <label
                      htmlFor="default-radio-2"
                      className="ms-2 text-xs 2xl:text-sm  text-gray-900"
                    >
                      Filter Data
                    </label>
                  </div>
                </div>
                {ExportFormik.values.type === "filter" && (
                  <>
                    <FormikSelectTwo
                      label="Type"
                      Options={type}
                      formik={ExportFormik}
                      placeholder="Choose"
                      name="typeEquipment"
                      width="w-full  "
                    />
                    <NuInput
                      label="Location"
                      name="location"
                      formik={ExportFormik}
                      placeholder="Enter location"
                      width="w-full"
                    />
                    <FormikSelectTwo
                      label="Unit"
                      Options={units}
                      formik={ExportFormik}
                      placeholder="Choose"
                      name="unit"
                      width="w-full"
                    />
                  </>
                )}
                <div className="flex w-full justify-end gap-2">
                  <CancelButton handleClick={closeFilterDialogebox} />
                  <SubmitButton name="Export" />
                </div>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
}
export default EquipDetailsIndex;